module.exports = __webpack_public_path__ + "static/soda-logo-1eaa8da433a6618c7b0529bed90a98cb.png";